import { Fragment, useEffect, useState } from 'react';
import "../FilePage/FilePage.css";
import SidePanel from '../../Components/SidePanel/SidePanel';
import Form from 'react-bootstrap/Form';
import Table from "react-bootstrap/Table";
import Paginations from '../../Components/Paginations/Paginations';
import { useNavigate } from 'react-router-dom';
import FilePageService from '../../API/FilePage/FilePageService';
import { useTranslation } from 'react-i18next';
// import logo from "../../ass-logo.png"
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Loading from '../../Common/Loading';
import { BsPatchExclamation } from 'react-icons/bs';
import AddQuotationBasis from './AddQuotationBasis';
import EditQuotationBasis from './EditQuotationBasis';

const QuotationBasisList = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [quotationBasisList, setQuotationBasisList] = useState([]);

    const [quotationBasisStatus, setQuotationBasisStatus] = useState("");
    const [updateQuotationBasisStatus, setUpdateQuotationBasisStatus] = useState("");
    const [quotationBasisId, setQuotationBasisId] = useState("");
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [logoImageShow, setLogoImageShow] = useState("");
    const [rightPanelThemeColor, setRightPanelThemeColor] = useState("");
    const [isRotated, setIsRotated] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);
    const [sort, setSort] = useState({ key: "created_at", value: "desc" });

    const [showmodal, setShowmodal] = useState(false);
    const handleModalShow = () => setShowmodal(true);
    const handleModalClose = () => setShowmodal(false);

    const [showAddcol, setShowAddcol] = useState(false);
    const handleAddcolClose = () => setShowAddcol(false);
    const handleAddcolShow = () => setShowAddcol(true);

    const [showAddQuotationBasisModal, setShowAddQuotationBasisModal] = useState(false);
    const handleAddQuotationBasisModalOpen = () => setShowAddQuotationBasisModal(true);
    const handleAddQuotationBasisModalClose = () => setShowAddQuotationBasisModal(false);

    const [showEditQuotationBasisModal, setShowEditQuotationBasisModal] = useState(false);
    const handleEditQuotationBasisModalOpen = () => setShowEditQuotationBasisModal(true);
    const handleEditQuotationBasisModalClose = () => setShowEditQuotationBasisModal(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const [modalColumns, setModalColumns] = useState({
        Nom: true,
        "Produit assureur": true,
        "Créé par": true,
        status: true,
    });

    const [selectedColumns, setSelectedColumns] = useState(
        Object.keys(modalColumns).filter((key) => modalColumns[key])
    );

    useEffect(() => {
        if (deletePermission) {
            setModalColumns((prev) => ({
                ...prev,
                Action: true,
            }));
            const newSelectedColumns = Object.keys(modalColumns).filter(
                (key) => modalColumns[key]
            );
            newSelectedColumns.push("Action");
            setSelectedColumns(newSelectedColumns);
        }
    }, [deletePermission]);

    useEffect(() => {
        const userRole = JSON.parse(localStorage.getItem("userRole"));
        const token = localStorage.getItem("authToken");
        const can_delete_folder = JSON.parse(localStorage.getItem("can_delete_folder"));
        setDeletePermission(can_delete_folder == 1 ? true : false);
        if (token && userRole.includes("Assureur")) {
            const logo_image = JSON.parse(localStorage.getItem("logo_image"));
            const right_panel_color = JSON.parse(localStorage.getItem("right_panel_color"));
            setRightPanelThemeColor(right_panel_color);
            setLogoImageShow(logo_image);
            QuotationBasisList(search, sort, currentPage, quotationBasisStatus);
        } else {
            navigate("/");
        }
    }, [sort]);

    const QuotationBasisList = async (search, sort, page = 1, status) => {
        setIsLoading(true);
        try {
            var userData = {
                search: search,
                sort: {
                    key: sort.key,
                    value: sort.value
                },
                status: status,
                page
            }
            const response = await FilePageService.quotation_basis_list(userData);
            if (response.data.status) {
                setIsLoading(false);
                setQuotationBasisList(response.data.quotation_basis.data);
                setCurrentPage(response.data.quotation_basis.meta.current_page);
                setTotalPages(response.data.quotation_basis.meta.last_page);
                setTotalRecords(response.data.quotation_basis.meta.total);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };



    const HandleDeleteDocumentFile = async () => {
        try {
            const response = await FilePageService.quotation_basis_destroy(quotationBasisId);
            if (response.data.status) {
                handleCloseDeleteModal();
                setQuotationBasisId("");
                QuotationBasisList(search, sort, currentPage, quotationBasisStatus);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const HandleUpdateStatus = async () => {
        try {
            var useData = {
                status: updateQuotationBasisStatus == 1 ? "0" : "1",
            };
            const response = await FilePageService.quotation_basis_update_status(quotationBasisId, useData);
            if (response.data.status) {
                setQuotationBasisStatus("");
                QuotationBasisList(search, sort, currentPage, "");
                handleModalClose();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSearchChange = (search) => {
        setSearch(search);
        QuotationBasisList(search, sort, 1, quotationBasisStatus);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearchChange(search);
        }
    };

    const HandleFilterStatus = (status) => {
        setQuotationBasisStatus(status);
        QuotationBasisList(search, sort, 1, status);
    };

    const handleStatusChange = (id, status) => {
        setQuotationBasisId(id);
        setUpdateQuotationBasisStatus(status);
        handleModalShow();
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        QuotationBasisList(search, sort, page, quotationBasisStatus);
    };

    const handleCheckboxChange = (key) => {
        setModalColumns((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleAddcolSubmit = () => {
        const newSelectedColumns = Object.keys(modalColumns).filter(
            (key) => modalColumns[key]
        );
        setSelectedColumns(newSelectedColumns);
        handleAddcolClose();
    };

    const handleClickRotate = (column) => {
        const direction = sort.key === column ? sort.value === "desc" ? "asc" : "desc" : "asc";
        setSort({ key: column, value: direction });
        setIsRotated(!isRotated);
    };

    const handleAddQuotationBasisModalCloseAfterAPICall = () => {
        setShowAddQuotationBasisModal(false);
        QuotationBasisList(search, sort, currentPage, quotationBasisStatus);
    };

    const handleEditQuotationBasisModalCloseAfterAPICall = () => {
        setShowEditQuotationBasisModal(false);
        QuotationBasisList(search, sort, currentPage, quotationBasisStatus);
    };

    return (
        <Fragment>
            <style> {` button.btn.btn-primary  { background-color: ${localStorage.getItem('button_color') ? JSON.parse(localStorage.getItem('button_color')) : "#e84455"} !Important};`} </style>

            <SidePanel sidebarLogo={(logoImageShow != "" || logoImageShow != null || logoImageShow != undefined) && `${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`} />

            <div className="dashboard-main-content insurers-dashboard" style={{ backgroundColor: rightPanelThemeColor }}>
                <div className="top-header">
                    <h4>Base de devis</h4>

                    <div className="mt-3 d-md-flex justify-content-between align-items-center">
                        <h1 className="m-md-0 mb-3">Liste des bases de cotation ({totalRecords})</h1>
                        <button onClick={handleAddQuotationBasisModalOpen} className="big-btn-icon">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="white" />
                            </svg>
                            Ajouter une base de devis
                        </button>
                        <AddQuotationBasis
                            showmodal={showAddQuotationBasisModal}
                            handleModalClose={handleAddQuotationBasisModalClose}
                            handleAddQuotationBasisModalCloseAfterAPICall={handleAddQuotationBasisModalCloseAfterAPICall}
                        />
                    </div>
                </div>
                <div className="table-wrapper mt-32">
                    <div className="d-md-flex align-aitems-center gap-2 justify-content-between">
                        <h2 className='m-md-0 mb-3'>
                            {/* Dossiers ({totalRecords}) */}
                        </h2>
                        <Form.Group
                            className="relative"
                            controlId="exampleForm.ControlInput1"
                        >
                            <Form.Control
                                type="search"
                                placeholder="Rechercher"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={handleKeyPress}
                            />
                            <div
                                className="search-icon"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSearchChange(search)}
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.7549 11.2549H11.9649L11.6849 10.9849C12.6649 9.84488 13.2549 8.36488 13.2549 6.75488C13.2549 3.16488 10.3449 0.254883 6.75488 0.254883C3.16488 0.254883 0.254883 3.16488 0.254883 6.75488C0.254883 10.3449 3.16488 13.2549 6.75488 13.2549C8.36488 13.2549 9.84488 12.6649 10.9849 11.6849L11.2549 11.9649V12.7549L16.2549 17.7449L17.7449 16.2549L12.7549 11.2549ZM6.75488 11.2549C4.26488 11.2549 2.25488 9.24488 2.25488 6.75488C2.25488 4.26488 4.26488 2.25488 6.75488 2.25488C9.24488 2.25488 11.2549 4.26488 11.2549 6.75488C11.2549 9.24488 9.24488 11.2549 6.75488 11.2549Z"
                                        fill="#998f90"
                                    />
                                </svg>
                            </div>
                        </Form.Group>
                    </div>

                    {isLoading ? <Loading /> :
                        <div className="table-wrap mt-24">
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        {selectedColumns.includes("Nom") &&
                                            <th>
                                                <div className="d-flex align-items-center">
                                                    <span>Nom</span>
                                                    <Link
                                                        className={`sorting-icon ms-2`}
                                                        onClick={() => handleClickRotate("name")}
                                                    >
                                                        {sort.value === "asc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                            </svg>
                                                        }

                                                        {sort.value === "desc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                            </svg>
                                                        }
                                                    </Link>
                                                </div>
                                            </th>
                                        }
                                        {selectedColumns.includes("Produit assureur") &&
                                            <th>
                                                <div className="d-flex align-items-center">
                                                    <span>Produit assureur</span>
                                                    <Link
                                                        className={`sorting-icon ms-2`}
                                                        onClick={() => handleClickRotate("insurer_product_id")}
                                                    >
                                                        {sort.value === "asc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                            </svg>
                                                        }

                                                        {sort.value === "desc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                            </svg>
                                                        }
                                                    </Link>
                                                </div>
                                            </th>
                                        }
                                        {selectedColumns.includes("Créé par") &&
                                            <th>
                                                <div className="d-flex align-items-center">
                                                    <span>{t("Créé par")}</span>
                                                    <Link
                                                        className={`sorting-icon ms-2`}
                                                        onClick={() => handleClickRotate("created_by")}
                                                    >
                                                        {sort.value === "asc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                            </svg>
                                                        }

                                                        {sort.value === "desc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                            </svg>
                                                        }
                                                    </Link>
                                                </div>
                                            </th>
                                        }
                                        {selectedColumns.includes("status") && (
                                            <th className="select-drop">
                                                <div className="d-flex align-items-center">
                                                    <div>
                                                        <Form.Select
                                                            aria-label="statusSelectAria"
                                                            value={quotationBasisStatus}
                                                            onChange={(e) => HandleFilterStatus(e.target.value)}
                                                        >
                                                            <option value="">{t("status")}</option>
                                                            <option value={0}>{t("inActiveLabel")}</option>
                                                            <option value={1}>{t("activeLabel")}</option>
                                                        </Form.Select>
                                                    </div>
                                                    <div>
                                                        <Link
                                                            className={`sorting-icon ms-2`}
                                                            onClick={() => handleClickRotate("status")}
                                                        >
                                                            {sort.value === "asc" &&
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                    <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                                </svg>
                                                            }

                                                            {sort.value === "desc" &&
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                    <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                                </svg>
                                                            }
                                                        </Link>
                                                    </div>
                                                </div>
                                            </th>
                                        )}
                                        {selectedColumns.includes("Action") && deletePermission && <th>Action</th>}
                                        <th style={{ textAlign: "right" }}>
                                            <Link onClick={handleAddcolShow}>
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 14 14"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black" />
                                                </svg>
                                            </Link>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(quotationBasisList?.length > 0 && selectedColumns?.length > 0) ? (
                                        quotationBasisList.map((data) => (
                                            <tr key={data.id}>
                                                {selectedColumns.includes("Nom") && (
                                                    <td className="bold-font" style={{ textAlign: "center" }}>
                                                        <div style={{ lineHeight: 1 }}>
                                                            {data.is_important == 1 && <BsPatchExclamation style={{ color: "red", fontSize: "1.0rem", cursor: "pointer" }} title='Nom' />}
                                                            <div style={{ marginTop: "4px" }}>{data?.name}</div>
                                                        </div>
                                                    </td>
                                                )}
                                                {selectedColumns.includes("Produit assureur") && <td>{data?.product_name}</td>}
                                                {selectedColumns.includes("Créé par") && <td>{data.created_by_name}</td>}
                                                {selectedColumns.includes("status") &&
                                                    <td>
                                                        {data.status == 1 ?
                                                            <span className="verified badges" onClick={() => handleStatusChange(data.id, data.status)} style={{ cursor: "pointer" }}>
                                                                {t("activeLabel")}
                                                            </span>
                                                            :
                                                            <span className="incomplete badges" onClick={() => handleStatusChange(data.id, data.status)} style={{ cursor: "pointer" }}>
                                                                {t("inActiveLabel")}
                                                            </span>
                                                        }
                                                    </td>
                                                }
                                                {selectedColumns.includes("Action") && deletePermission && (
                                                    <td>
                                                        <div className="action-btn">
                                                            <Link
                                                                className="edit"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setQuotationBasisId(data.id);
                                                                    handleEditQuotationBasisModalOpen();
                                                                }}
                                                            >
                                                                <svg
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 6.19L2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19Z"
                                                                        fill="#00366B"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                            {showEditQuotationBasisModal &&
                                                                <EditQuotationBasis
                                                                    showmodal={showEditQuotationBasisModal}
                                                                    handleModalClose={handleEditQuotationBasisModalClose}
                                                                    handleEditQuotationBasisModalCloseAfterAPICall={handleEditQuotationBasisModalCloseAfterAPICall}
                                                                    selectedId={quotationBasisId}
                                                                />
                                                            }
                                                            <Link
                                                                className="delete"
                                                                href="/user-management"
                                                                data-discover="true"
                                                                title="Supprimer"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleShowDeleteModal();
                                                                    setQuotationBasisId(data.id);
                                                                }}
                                                            >
                                                                <svg
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                                                        fill="#00366B"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                        </div>
                                                    </td>
                                                )}
                                                <td></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr style={{ textAlign: "center" }}>
                                            <td colSpan="11">{t("NorecordsfoundLabel")}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>}
                    {totalRecords > 10 &&
                        <Paginations
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            itemsPerPage={10}
                            totalItems={totalRecords}
                        />
                    }
                </div>
            </div>

            {/* Add Col Modal */}
            <Modal show={showAddcol} onHide={handleAddcolClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une colonne</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h2 className="mb-4">Liste des colonnes</h2>
                    {/* Select All Checkbox */}
                    <Form.Check
                        id="select-all-checkbox"
                        label="Sélectionner tout"
                        checked={Object.values(modalColumns).every((value) => value)} // All true
                        onChange={(e) => {
                            const isChecked = e.target.checked;
                            setModalColumns((prev) =>
                                Object.fromEntries(Object.keys(prev).map((key) => [key, isChecked]))
                            );
                        }}
                    />

                    {/* Individual Column Checkboxes */}
                    {Object.keys(modalColumns).map((key) => (
                        <Form.Check
                            key={key}
                            id={`checkbox-${key}`}
                            label={<label style={{ cursor: "pointer" }} htmlFor={`checkbox-${key}`}>{t(key)}</label>}
                            checked={modalColumns[key]}
                            onChange={() => handleCheckboxChange(key)}
                        />
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleAddcolSubmit}>
                        Ajouter
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Popup */}
            <Modal className="final-modal" show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title><h2>Confirmation</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Êtes-vous sûr de vouloir supprimer la base de devis ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="cancel-btn" variant="primary" onClick={handleCloseDeleteModal}>
                        {t("cancelLabel")}
                    </Button>
                    <Button variant="primary" onClick={HandleDeleteDocumentFile}>
                        {t("confirmbtnLabel")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Confirmation Popup */}
            <Modal className='missing-doc-modal' show={showmodal} onHide={() => setShowmodal(true)}>
                <Modal.Header closeButton onHide={handleModalClose}>
                    <Modal.Title>
                        <h2>{t("confirmStatusTitle")}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="complete-process">
                        {t("confirmStatusMessage")}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <div className="text-end">
                        <Button variant="primary" onClick={() => HandleUpdateStatus()}>
                            {t("confirmbtnLabel")}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default QuotationBasisList;